import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { CancelablePromise } from '../request/cancelable-promise';
import { type ConnectPatientAndCaregiverResponseDto } from 'types/types';

export const connectPatientAndCaregiver = (email: string): CancelablePromise<ConnectPatientAndCaregiverResponseDto> => {
  return __request(OpenAPI, {
    method: 'POST',
    url: `/connect/patient/`,
    body: {
      email,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const deletePatientAndCaregiver = (patientEmail: string): CancelablePromise<void> => {
  return __request(OpenAPI, {
    method: 'DELETE',
    url: `/connect/email/${patientEmail}`,
    path: {
      email: patientEmail,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
